import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {InvoicePO, PaybackPO} from "@/model/finance";
import {WriteInvoiceForm} from "@/pages/Invoice/WriteInvoice";
import {WriteInvoicingForm} from "@/widget/ProcessApproval/WriteInvoicing";
import {ContractPO} from "@/model/customer";

export enum InvoiceEnum {
    GetInvoicePage = "/invoice/getInvoicePage",
    GetInvoice = "/invoice/getInvoice",
    CreateInvoice = "/invoice/createInvoice",
    UpdateInvoice = "/invoice/updateInvoice",
    CreateInvoicing = "/invoice/createInvoicing",
}

export interface InvoicePageBO {
    keyword?: string;
}

export interface InvoicePageVO extends ReviewStatusVO, InvoicePO {
}

export interface InvoiceVO extends InvoicePO {
    paybacks: PaybackPO[];
    contract: ContractPO
}

export const useQueryInvoicePage = () => useMutation({
    mutationFn: (data: InvoicePageBO) => http.post<BaseVO<PaginationVO<InvoicePageVO>>>({
        url: InvoiceEnum.GetInvoicePage,
        data: data,
    }),
})

export const useCreateInvoicing = () => useMutation({
    mutationFn: ({instanceId, businessId, invoiceTax, ...rest}: WriteInvoicingForm) => http.put({
        url: InvoiceEnum.CreateInvoicing,
        data: {
            ...rest, instanceId: instanceId,
            businessId: businessId, invoiceTax,
        }
    }),
})

export const useCreateInvoice = () => useMutation({
    mutationFn: (data: WriteInvoiceForm) => http.put({url: InvoiceEnum.CreateInvoice, data}),
})


export const useUpdateInvoice = () => useMutation({
    mutationFn: (data: WriteInvoiceForm) => http.post({url: InvoiceEnum.UpdateInvoice, data}),
})

export const useQueryInvoice = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<InvoiceVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<InvoiceVO>>({
        url: InvoiceEnum.GetInvoice,
        params: params
    }),
    enabled
})


